import { validateField } from './helper';

export const CREATE_FIELD = 'CREATE_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const DELETE_FIELD = 'DELETE_FIELD';
export const UPDATE_FORM = 'UPDATE_FORM';
export const RESET_FORM = 'RESET_FORM';

const DEFAULT_FIELD_VALUE = {
  initialValue: '',
  value: '',
  validators: {},
  error: false,
  errorKey: '',
};

export default (state, action) => {
  const { type, payload = {} } = action;
  const { valuesObj, field, value, validators } = payload;

  switch (type) {
    case CREATE_FIELD: {
      // If field does not exist
      if (!state.fields?.[field]) {
        // Generate field data with initial values & validators
        const initField = {
          ...DEFAULT_FIELD_VALUE,
          ...(value !== undefined ? { initialValue: value } : {}),
          ...(value !== undefined ? { value } : {}),
          ...(validators !== undefined ? { validators } : {}),
        };

        // Insert new field to existing state
        const fields = { ...state.fields, [field]: initField };
        return { ...state, fields };
      }

      return state;
    }
    case UPDATE_FIELD: {
      if (state.fields && state.fields?.[field]) {
        // Update field with new value & validator
        const prevField = state.fields[field];
        const newField = {
          ...prevField,
          ...(value !== undefined ? { value } : {}),
          ...(validators !== undefined ? { validators } : {}),
        };
        // Run validation
        const errorData = validateField(newField.value, newField.validators);
        // Update field with validation result
        const validatedField = {
          ...newField,
          error: errorData?.errorMessage,
          errorKey: errorData?.errorKey,
        };
        // Insert new field to existing state
        const fields = { ...state.fields, [field]: validatedField };
        return { ...state, fields, hasFieldsChanged: true };
      }
      return state;
    }
    case DELETE_FIELD: {
      const fields = { ...state.fields };
      if (fields?.[field]) {
        delete fields[field];
        return {
          fields,
        };
      }
      return state;
    }
    case RESET_FORM: {
      return {
        fields: valuesObj,
        hasFieldsChanged: false,
      };
    }
    case UPDATE_FORM: {
      return {
        fields: valuesObj,
        hasFieldsChanged: true,
      };
    }

    default:
      return state;
  }
};
